import SiteFooter from "../components/SiteFooter";
import PublicPageHeader from "../components/PublicPageHeader";

const RefundPage = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: "var(--secondary)" }}>
      <PublicPageHeader />
      <main className="px-6 py-12">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl border p-8 md:p-10" style={{ borderColor: "var(--border)" }}>
          <h1 className="text-4xl font-bold mb-2" style={{ fontFamily: "Fraunces, serif", color: "var(--primary)" }}>
            Refund & Cancellation Policy
          </h1>
          <p className="text-sm opacity-60 mb-8">Effective Date: April 9, 2026</p>

          <div className="space-y-6 text-[15px] leading-7 opacity-90">

            <section>
              <h2 className="text-lg font-semibold mb-2">1. Overview</h2>
              <p>
                MoolTax provides tax filing support services that involve professional time,
                document review, and coordination effort. This policy outlines the conditions
                under which cancellations and refunds may be considered.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">2. Cancellation Before Work Begins</h2>
              <p>
                If you have made a payment and no document review or filing work has commenced
                on your case, you may request a cancellation within <strong>48 hours</strong> of
                payment by writing to support@mooltax.com. Such requests will be reviewed and,
                if eligible, a refund will be processed.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">3. After Work Has Commenced</h2>
              <p>
                Once document review, case assessment, or any preparation activity has begun
                on your filing request, the fee paid is non-refundable. This is because
                professional effort and time have already been applied to your case.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">4. Duplicate Payments</h2>
              <p>
                If you have been charged more than once for the same service due to a
                technical error, please contact us within 7 days at support@mooltax.com
                with your payment reference. Verified duplicate charges will be refunded in full.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">5. Failed Transactions</h2>
              <p>
                If your payment was deducted but the transaction did not complete successfully
                on our platform, the amount will typically be reversed by your bank or payment
                provider within 5–7 business days. If not received within that period,
                contact us with your transaction details.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">6. Refund Timeline</h2>
              <p>
                Approved refunds will be processed within <strong>7–15 business days</strong>.
                The actual credit to your account depends on your bank or payment provider.
                Refunds are returned to the original payment method used at the time of purchase.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">7. How to Request a Refund</h2>
              <p>To request a refund, email us at{" "}
                <a href="mailto:support@mooltax.com" className="underline">support@mooltax.com</a>{" "}
                with:
              </p>
              <ul className="list-disc pl-6 space-y-1 mt-2">
                <li>Your registered email address</li>
                <li>Payment reference or transaction ID</li>
                <li>Reason for refund request</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold mb-2">8. Contact</h2>
              <p>
                For refund or cancellation queries, contact us at{" "}
                <a href="mailto:support@mooltax.com" className="underline">support@mooltax.com</a>{" "}
                or through the Contact Us page.
              </p>
            </section>

          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
};

export default RefundPage;
